import { Component } from '@angular/core'
import { FilterProductsService } from '../../services/filter-products.service'
import { map, shareReplay } from 'rxjs/operators'

@Component({
  selector: 'mb-pdp-product-filters',
  templateUrl: './pdp-product-filters.component.html',
})
export class PdpProductFiltersComponent {

  primaryFilter$ = this.filterProductsService.filteredFacets$.pipe(
    map(fd => fd?.find(v => v.isPrimaryFilter)),
    shareReplay(1)
  )
  nonPrimaryFilters$ = this.filterProductsService.filteredFacets$.pipe(
    map(fd => fd?.filter(v => !v.isPrimaryFilter)),
    shareReplay(1)
  )

  constructor (protected filterProductsService: FilterProductsService) {
  }
}
